
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusserviceinkharbwadi() {



const cardData = {
  keyword: ' Cab and Bus Services in Kharbwadi',
  heading: 'eTravo:  Cab and Bus Services in Kharbwadi',
  headingDescription: `eTravo offers efficient and reliable corporate cab and bus services in Kharbwadi MIDC, one of Pune’s prominent industrial zones known for housing major automobile, engineering, and manufacturing units. Our transport solutions are designed to support companies with seamless employee commutes, executive travel, and shift-based workforce movement.`,

  top: 'Top Places to visit in Pune with eTravo',
"topPlaces": [
  {
    "title": "Chakan MIDC Industrial Area",
    "description": "Located adjacent to Kharabwadi, Chakan MIDC is a major industrial hub housing automotive giants like Volkswagen, Mercedes-Benz, and Bajaj Auto. eTravo offers reliable employee transportation solutions, ensuring timely commutes for workers and executives, thereby enhancing operational efficiency."
  },
  {
    "title": "Sara Abhiman Residential Project",
    "description": "Sara Abhiman is a prominent residential development in Kharabwadi, offering modern amenities and well-planned living spaces. eTravo provides convenient cab services for residents, facilitating daily commutes to workplaces, schools, and other essential destinations."
  },
  {
    "title": "Podar International School, Chakan",
    "description": "Situated approximately 1.5 km from Kharabwadi, Podar International School is a reputed educational institution. eTravo ensures safe and punctual transportation for students and staff, supporting the academic community with dependable travel solutions."
  },
  {
    "title": "Ayush Hospital",
    "description": "Located within Kharabwadi, Ayush Hospital offers essential healthcare services to the local population. eTravo provides accessible transportation options for patients and medical professionals, ensuring timely access to medical care."
  },
  {
    "title": "Panchratna Complex Bus Stop",
    "description": "A key transit point in Kharabwadi, the Panchratna Complex Bus Stop connects residents to various parts of Pune. eTravo complements public transport by offering first and last-mile connectivity, enhancing overall commuting convenience."
  },
  {
    "title": "Kharabwadi Gram Panchayat Office",
    "description": "The administrative center for Kharabwadi, the Gram Panchayat Office handles local governance and civic issues. eTravo facilitates transportation for officials and residents attending meetings or accessing public services."
  },
  {
    "title": "Mahadevi Mandir",
    "description": "A revered temple in Kharabwadi, Mahadevi Mandir is a spiritual center for the local community. eTravo offers transportation services for devotees, especially during festivals and special occasions, ensuring comfortable travel experiences."
  },
  {
    "title": "Rock Fitness Club",
    "description": "Rock Fitness Club is a popular gym in Kharabwadi, promoting health and wellness among residents. eTravo provides convenient cab services for fitness enthusiasts, supporting their regular workout routines."
  },
  {
    "title": "Star Mart Supermarket",
    "description": "Located nearby in Chakan, Star Mart offers a wide range of groceries and household items. eTravo assists shoppers with reliable transportation, making shopping trips more convenient and efficient."
  },
  {
    "title": "Siddhant College of Engineering",
    "description": "Approximately 8.4 km from Kharabwadi, Siddhant College of Engineering is a notable institution for higher education. eTravo ensures timely and safe transportation for students and faculty, supporting academic pursuits."
  }
],

services: [
  {
    name: 'Kharbwadi Corporate Transport Solutions',
    description: `Comprehensive corporate transport services for businesses in Kharbwadi. Our monthly plans include employee and executive mobility, backed by professional drivers, route planning, and support across shifts.`
  },
  {
    name: 'Bus & Cab Hire for Companies in Kharbwadi',
    description: `Flexible monthly bus and cab hire services tailored for companies in Kharbwadi. Ideal for regular staff commutes or operational needs, with AC/non-AC options, GPS tracking, and fixed monthly billing.`
  },
  {
    name: 'Daily Staff Shuttle Kharbwadi MIDC',
    description: `Daily shuttle services for staff working in and around Kharbwadi MIDC. Designed to accommodate shift patterns with timely pickups and drop-offs using vans or minibuses operated by trained drivers.`
  },
  {
    name: 'Affordable Corporate Commute Services Kharbwadi',
    description: `Cost-effective commute packages for corporate teams in Kharbwadi. These plans balance budget and efficiency, helping organizations reduce transport overhead while ensuring timely mobility.`
  },
  {
    name: 'AC Cabs and Buses for Offices Kharbwadi',
    description: `Air-conditioned cab and bus rentals ideal for offices in Kharbwadi. Ensure employee comfort year-round with well-maintained vehicles and experienced chauffeurs under reliable monthly plans.`
  },
  {
    name: 'Reliable Employee Pickup & Drop Kharbwadi',
    description: `Trusted pickup and drop services for corporate employees in Kharbwadi. With punctual operations, fixed routes, and real-time tracking, this service supports daily attendance and workforce efficiency.`
  }
],

tableData: [
  ['Kharbwadi Corporate Transport Solutions', 'Bus & Cab Hire for Companies in Kharbwadi'],
  ['Daily Staff Shuttle Kharbwadi MIDC', 'Affordable Corporate Commute Services Kharbwadi'],
  ['AC Cabs and Buses for Offices Kharbwadi', 'Reliable Employee Pickup & Drop Kharbwadi']
],




"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab and Bus Services in Kharbwadi",
    "WhyChoosedescription": "eTravo offers reliable and efficient cab and bus services for corporate clients in Kharbwadi, ensuring timely and comfortable transportation for your employees."
  },
  {
    "WhyChooseheading": "Diverse Fleet Catering to Various Transport Needs",
    "WhyChoosedescription": "Choose from a wide range of vehicles including sedans, SUVs, and buses to suit the specific commuting requirements of your workforce in Kharbwadi."
  },
  {
    "WhyChooseheading": "Shift-Aligned Transport Solutions for Industrial Workflows",
    "WhyChoosedescription": "Our transport services are designed to match industrial shift schedules, ensuring smooth and punctual employee pick-up and drop-off."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Route Expertise",
    "WhyChoosedescription": "Our professional drivers are familiar with Kharbwadi’s roads and traffic patterns, guaranteeing safe and efficient travel."
  },
  {
    "WhyChooseheading": "GPS-Enabled Vehicles for Real-Time Monitoring",
    "WhyChoosedescription": "All vehicles are equipped with GPS tracking systems for real-time location updates, enhancing security and operational transparency."
  },
  {
    "WhyChooseheading": "Transparent Monthly Billing with Detailed Invoices",
    "WhyChoosedescription": "We provide clear and itemized monthly invoices, making it easy for businesses to manage transportation expenses."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Protocols",
    "WhyChoosedescription": "Regular sanitization and maintenance of vehicles ensure a clean and safe environment for all passengers."
  },
  {
    "WhyChooseheading": "Dedicated Account Management and Support",
    "WhyChoosedescription": "Our dedicated support team handles all aspects of your corporate transportation, ensuring smooth and hassle-free operations."
  }
]















}

const faqData = [
  [
    {
      question: "Which areas do your corporate cab and bus services cover?",
      answer: "We provide corporate transportation services in Pune and nearby industrial hubs, including Kharbwadi, Talegaon, Bhosari, and adjacent zones."
    },
    {
      question: "Can we customize transport plans according to shift timings and employee strength?",
      answer: "Yes, we offer flexible transport packages tailored to your company’s specific shift schedules, workforce size, and route preferences."
    },
    {
      question: "Do you offer GST-compliant corporate billing?",
      answer: "Absolutely. Our monthly corporate transport plans include consolidated GST-compliant invoices and detailed travel reports."
    },
    {
      question: "Are professional drivers part of your transportation services?",
      answer: "Yes, all our drivers are professionally trained, verified, and experienced in corporate transportation requirements."
    },
    {
      question: "What safety protocols do you follow for employee transportation?",
      answer: "Our vehicles are GPS-enabled, sanitized regularly, and maintained to ensure maximum safety. Drivers undergo strict verification and training."
    },
    {
      question: "Is dedicated support provided for daily transport coordination?",
      answer: "Yes, we provide dedicated transport coordinators and real-time tracking to streamline daily employee commute management."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Anil Pawar",
    designation: "Facility Manager, Kharbwadi Industries Pvt. Ltd.",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s corporate transport service in Kharbwadi is dependable and well-organized. Our employees commute safely and on time every day.”"
  },
  {
    name: "Ms. Kavita More",
    designation: "HR Head, Pune Manufacturing Corp.",
    rating: [1, 1, 1, 1, 1],
    text: "“The team at eTravo provides excellent support and seamless transport solutions tailored for Kharbwadi’s industrial workforce.”"
  }
];



















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services in Kharbwadi",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-kharbwadi.jpg",
  "description": "Book corporate cab and bus services in Kharbwadi with eTravo for daily staff shuttle, office commute, and employee pickup & drop. Affordable and reliable AC cabs and buses tailored for companies in Kharbwadi MIDC.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5657"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2299",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-in-kharbwadi"
  }
};






    return (
        <div>

<Helmet>
  <title>Corporate Cab and Bus Services in Kharbwadi | Staff Transport & Office Shuttle | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Kharbwadi with eTravo for employee transport, daily shuttle, and office commute. Reliable AC cabs and buses for companies in Kharbwadi MIDC." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/101.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusserviceinkharbwadi;